/*
 * shared Actions
 *
 * @version 1.0.0
 * @author Giuseppe
 * @since 01-Feb-2023
 */

import { createRequestTypes, createAction, MakeRequest } from './index';

/*
	HERE: READ ME!
	Actions are added here, which can be called up in several places in the portal, and are thus shared.
	For example the fetchGroupList. This Action is used both in the GroupList.jsx and within other flows in the PortalModalFields components.
	Consequently, they are used as global Actions to avoid duplicating Sagas and States.
*/

export const actionTypes = {
	DO_RESET_SHARED_STATE: '@@Shared/reset_shared_state',
	DO_RESET_SHARED_STORES: '@@Shared/reset_shared_stores',
	DO_RESET_SHARED_GROUPS: '@@Shared/reset_shared_groups',
	DO_RESET_SHARED_MERCHANTS: '@@Shared/reset_shared_merchants',
	DO_RESET_SHARED_TRANSACTIONS: '@@Shared/reset_shared_transactions',
	// @generator action:type
	...createRequestTypes('@@Store', 'LIST_STORES'),
	...createRequestTypes('@@Store', 'FIND_STORE'),
	...createRequestTypes('@@Register', 'LIST_REGISTERS'),
	...createRequestTypes('@@Groups', 'FETCH_GROUP_LIST'),
	...createRequestTypes('@@Groups', 'FETCH_GROUP_FIND'),
	...createRequestTypes('@@Merchant', 'FETCH_MERCHANT_LIST'),
	...createRequestTypes('@@Merchant', 'FETCH_MERCHANT_FIND'),
	...createRequestTypes('@@Transactions', 'FETCH_TRANSACTION_LIST'),
	...createRequestTypes('@@Transactions', 'FETCH_TRANSACTION_FIND'),
	// @generator action:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name listStores
 * @return {object} - The action object
 */
export const listStores = new MakeRequest('Store', 'list_stores');
/** @action request
 * * Insert a description
 * @name findStore
 * @return {object} - The action object
 */
export const findStore = new MakeRequest('Store', 'find_store');
/** @action request
 * * Insert a description
 * @name fetchGroupList
 * @return {object} - The action object
 */
export const listRegisters = new MakeRequest('Register', 'list_registers');
/** @action request
 * * Insert a description
 * @name fetchRegistersList
 * @return {object} - The action object
 */
export const fetchGroupList = new MakeRequest('Groups', 'fetch_group_list');
/** @action request
 * * Insert a description
 * @name fetchGroupFind
 * @return {object} - The action object
 */
export const fetchGroupFind = new MakeRequest('Groups', 'fetch_group_find');
/** @action request
 * * Insert a description
 * @name fetchMerchantList
 * @return {object} - The action object
 */
export const fetchMerchantList = new MakeRequest('Merchant', 'fetch_merchant_list');

/** @action request
 * * Insert a description
 * @name fetchMerchantFind
 * @return {object} - The action object
 */
export const fetchMerchantFind = new MakeRequest('Merchant', 'fetch_merchant_find');
/** @action request
 * * Insert a description
 * @name transactionList
 * @return {object} - The action object
 */
export const fetchTransactionList = new MakeRequest('Transactions', 'fetch_transaction_list');

/** @action request
 * * Insert a description
 * @name transactionFind
 * @return {object} - The action object
 */
export const fetchTransactionFind = new MakeRequest('Transactions', 'fetch_transaction_find');
// @generator action:request
/** @action
 * * Insert a description
 * @name ResetSharedState
 * @return {object} - The payload object
 */
export const doResetSharedState = (payload) => createAction(actionTypes.DO_RESET_SHARED_STATE, { payload });
/** @action
 * * Insert a description
 * @name ResetSharedStores
 * @return {object} - The payload object
 */
export const doResetSharedStores = (payload) => createAction(actionTypes.DO_RESET_SHARED_STORES, { payload });
/** @action
 * * Insert a description
 * @name ResetSharedGroups
 * @return {object} - The payload object
 */
export const doResetSharedGroups = (payload) => createAction(actionTypes.DO_RESET_SHARED_GROUPS, { payload });
/** @action
 * * Insert a description
 * @name ResetSharedMerchants
 * @return {object} - The payload object
 */
export const doResetSharedMerchants = (payload) => createAction(actionTypes.DO_RESET_SHARED_MERCHANTS, { payload });
/** @action
 * * Insert a description
 * @name ResetSharedTransactions
 * @return {object} - The payload object
 */
export const doResetSharedTransactions = (payload) =>
	createAction(actionTypes.DO_RESET_SHARED_TRANSACTIONS, { payload });
// @generator action
